// extracted by mini-css-extract-plugin
export default {"Loader":"IconLoader_Loader__jESZu","rotate":"IconLoader_rotate__9O-we","appLoaderAnim":"IconLoader_appLoaderAnim__GOFnT"};